var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-end items-center gap-2"},[_c('p',{staticClass:"text-white text-md sm:text-lg"},[_vm._v(" "+_vm._s(_vm.$translate('components.GetGasAvailable.title'))+" ")]),_c('p',{staticClass:"font-bold text-md sm:text-lg",class:{
      'text-white': _vm.isValid === null,
      'text-coral-red': _vm.isValid === false,
      'text-primary': _vm.isValid === true,
    }},[_vm._v(" "+_vm._s(_vm.neoOwned)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }